"use client";
import axios from "axios";
import { useEffect, useState } from "react";
import type React from "react";
import ErrorAlert from "../../components/ErrorAlert";
import ProjectList from "@/components/projects/projectlist";
import Link from "next/link";

interface Project {
  title: string;
  slug: string;
  summary?: string;
  content?: string;
  coverImageUrl?: string;
  tags?: string[];
  sections?: ProjectSection[];
  createdAt: Date;
  updatedAt: Date;
}
interface ProjectSection {
  type: string; // e.g., 'hero', 'text'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

export default function Projects() {
  const [error] = useState("");
  const [projects, setProjects] = useState<Project[]>([
    {
      slug: "lorem-ipsum",
      title: "Lorem Ipsum",
      summary: "Lorem ipsum dolor sit amet",
      content: "",
      coverImageUrl: "",
      tags: [],
      sections: [],
      createdAt: new Date(),
      updatedAt: new Date(),
    },
  ]);

  useEffect(() => {
    // Fetch projects from API
    axios
      .get<{ projects: Project[] }>("/api/projects") // Adjust API endpoint as needed
      .then((res) => {
        setProjects(res.data.projects);
        console.log("Projects fetched successfully:", res.data.projects);
      })
      .catch((err) => {
        console.log("Error fetching projects:", err);
      });
  }, []);

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 16,
          left: 16,
          zIndex: 2000,
        }}
      >
        <Link
          href="/"
          className="btn btn-primary"
          style={{
            borderRadius: 999,
            boxShadow: "0 6px 20px rgba(91, 33, 182, 0.25)",
            paddingInline: 16,
            paddingBlock: 8,
          }}
        >
          ← Home
        </Link>
      </div>
      <div
        className="container-fluid px-0"
        style={{ position: "relative", zIndex: 1 }}
      >
        <ErrorAlert message={error} />

        {/* Header Section */}
        <section className="py-5 text-center">
          <div className="container">
            <h1 className="display-4 fw-bold text-white">My Projects</h1>
            <p className="lead text-white-50">
              A summary of all my projects and achievements.
            </p>
          </div>
        </section>

        {/* Projects Section */}
        {<ProjectList projects={projects} />}
      </div>
    </>
  );
}
